module.exports = __webpack_public_path__ + "img/78cbed9.jpg";